"use strict";

exports.__esModule = true;
exports.getNativeTokenName = getNativeTokenName;
function getNativeTokenName(api) {
  return api.registry.chainTokens[0].toString();
}